export const mainConstants = {
  TOGGLE_SCREEN_SIZE: 'TOGGLE_SCREEN_SIZE',
  
  TOGGLE_SIDE_BAR: 'TOGGLE_SIDE_BAR',
  TOGGLE_ACTIVE_PAGE: 'TOGGLE_ACTIVE_PAGE',
  INSERT_ROUTES: 'INSERT_ROUTES',
  FETCH_ROUTES_START: 'FETCH_ROUTES_START',
  FETCH_ROUTES_SUCCESS: 'FETCH_ROUTES_SUCCESS',
  FETCH_ROUTES_FAILURE: 'FETCH_ROUTES_FAILURE',
  ENABLE_PAGING: 'ENABLE_PAGING',
  DISABLE_PAGING: 'DISABLE_PAGING',
  INSERT_PAGES: 'INSERT_PAGES',
  UPDATE_ERROR_MODAL: 'UPDATE_ERROR_MODAL',
  CLEAR_ERROR_MODAL: 'CLEAR_ERROR_MODAL'
};
